import AppConfig from './appConfig';
import {register} from "../app/http/register";
import {authenticate} from "../app/http/authenticate";
import {removeJWTToken, setJWTToken} from "../app/utils/getJWTToken";
import {parseJwt} from "../app/utils/parseJwt";
import {ROLE} from "./env";
/**
 * This service emulates an Authentication Service.
 */

/**
 * Fake authentication function that returns a promise that is either resolved or rejected.
 *
 * Given a username and password, checks that the username matches one of the known
 * usernames (this.usernames), and that the password matches 'password'.
 *
 * Delays 800ms to simulate an async REST API delay.
 */
//@ts-ignore
// const mockCheckCredentials = (username: string, password: string) => new Promise((resolve, reject) => {
//     // checks if the username is one of the known usernames, and the password is 'password'
//     //@ts-ignore
//     const validUsername = this.usernames.indexOf(username) !== -1;
//     const validPassword = password === 'password';
//     setTimeout(() => {
//         if (validUsername && validPassword) resolve(username);
//         else reject("Invalid username or password");
//     }, 800);
// });

class AuthService {
    usernames: any;

    constructor() {
        this.usernames = ['admin'];
    }

    isAuthenticated () {
        return !!AppConfig.emailAddress;
    }

    authenticate (username: string, password: string) {

        return authenticate(username, password)
            .then((result) => {
                const {jwtToken} = result;
                const userInfo = parseJwt(jwtToken);
                const {role} = userInfo;
                if (role !== ROLE) {
                    throw new Error('invalid user');
                }
                setJWTToken(jwtToken);
                AppConfig.emailAddress = userInfo.username ? username : undefined;
                AppConfig.isAdmin = userInfo.is_admin;
                AppConfig.save();
            }, (error) => {
                throw new Error(error);
            });
    }

    register (username: string, password: string) {

        return register(username, password)
            .then((result) => {
                const {jwtToken} = result;
                const userInfo = parseJwt(jwtToken);
                setJWTToken(jwtToken);
                AppConfig.emailAddress = userInfo.username ? username : undefined;
                AppConfig.isAdmin = userInfo.is_admin;
                AppConfig.save();
            }, (error) => {
                throw new Error(error);
            });
    }

    /** Logs the current user out */
    logout () {
        AppConfig.emailAddress = undefined;
        removeJWTToken();
        AppConfig.save();
    }
}

let instance = new AuthService();
export default instance;
